// src/components/template/DirectLogin.js
import React, { useEffect } from 'react';
import { useAuthentication } from '../auth/hooks/useAuthentication';

const DirectLogin = () => {
    const { keycloakLogin } = useAuthentication();

    useEffect(() => {
        keycloakLogin();
    }, [keycloakLogin]);

    return null;
};

export default DirectLogin;